import React from 'react';

// Simple, license-free SVG emblems inspired by rank colors/shapes.
// Not actual LoL assets. Each emblem is composed of geometric shapes and gradient fills.
// Props: key (rank key), size (px), title (accessible label)

const COLORS = {
  iron: ['#5f6769','#8a8f91'],
  bronze: ['#8d5524','#cd7f32'],
  silver: ['#9ea7ad','#c0c7cd'],
  gold: ['#b68600','#f1c40f'],
  platinum: ['#1abc9c','#7ed6df'],
  emerald: ['#0ea568','#2ecc71'],
  diamond: ['#4aa3ff','#74b9ff'],
  master: ['#7d3c98','#9b59b6'],
  grandmaster: ['#b03a2e','#e74c3c'],
  challenger: ['#2e86c1','#3498db']
};

function EmblemShape({ primary, secondary }) {
  return (
    <g>
      <defs>
        <linearGradient id="gradMain" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={secondary} />
          <stop offset="100%" stopColor={primary} />
        </linearGradient>
      </defs>
      <polygon points="50,5 63,20 80,28 85,45 80,62 63,70 50,85 37,70 20,62 15,45 20,28 37,20" fill="url(#gradMain)" stroke={primary} strokeWidth="2" />
      <circle cx="50" cy="45" r="12" fill={secondary} opacity="0.9" stroke={primary} strokeWidth="2" />
      <path d="M50 15 L60 28 L50 22 L40 28 Z" fill={secondary} opacity="0.8" />
      <path d="M50 75 L60 62 L50 68 L40 62 Z" fill={secondary} opacity="0.8" />
    </g>
  );
}

export default function RankEmblem({ rankKey, size = 56, title }) {
  const key = String(rankKey || '').toLowerCase();
  const [primary, secondary] = COLORS[key] || ['#666','#999'];
  const px = Number(size) || 56;
  const label = title || key || 'rank';
  return (
    <svg width={px} height={px} viewBox="0 0 100 100" role="img" aria-label={label} focusable="false">
      <title>{label}</title>
      <EmblemShape primary={primary} secondary={secondary} />
    </svg>
  );
}
